<template>
  <div class="fleet">
    <navs></navs>
    <div class="fleetBox">
      <p class="bigTitle">公司船队</p>
      <p class="smallTitle">COMPANY FLEET</p>
    </div>
    <div class="fleetInfo">
      <div class="innerFleet">
        <div>
          <img src="../assets/boat-1.png" class="boat">
          <p class="fleetName">船名：携船998</p>
          <p class="fleetSub"><span>载重吨：5051T</span><span>类型：散货船</span></p>
        </div>
      </div>
      <div class="innerFleet">
        <div>
          <img src="../assets/boat-2.png" class="boat">
          <p class="fleetName">船名：港联9</p>
          <p class="fleetSub"><span>载重吨：5023T</span><span>类型：多用途船</span></p>
        </div>
      </div>
    </div>
    <div class="fleetInfo">
      <div class="innerFleet">
        <div>
          <img src="../assets/boat-3.png" class="boat">
          <p class="fleetName">船名：携船1</p>
          <p class="fleetSub"><span>载重吨：5012T</span><span>类型：散货船</span></p>
        </div>
      </div>
      <div class="innerFleet">
        <div>
          <img src="../assets/boat-4.png" class="boat">
          <p class="fleetName">船名：携船6</p>
          <p class="fleetSub"><span>载重吨：5078T</span><span>类型：散货船</span></p>
        </div>
      </div>
    </div>
    <div class="fleetInfo">
      <div class="innerFleet">
        <div>
          <img src="../assets/boat-5.png" class="boat">
          <p class="fleetName">船名：携船66</p>
          <p class="fleetSub"><span>载重吨：5000T</span><span>类型：散货船</span></p>
        </div>
      </div>
      <div class="innerFleet">
        <div>
          <img src="../assets/boat-6.png" class="boat">
          <p class="fleetName">船名：携船168</p>
          <p class="fleetSub"><span>载重吨：5095T</span><span>类型：散货船</span></p>
        </div>
      </div>
    </div>
    <div class="fleetInfo">
      <div class="innerFleet">
        <div>
          <img src="../assets/boat-7.png" class="boat">
          <p class="fleetName">船名：携船轮</p>
          <p class="fleetSub"><span>载重吨：7583T</span><span>类型：多用途船</span></p>
        </div>
      </div>
      <div class="innerFleet">
        <div>
          <img src="../assets/boat-8.png" class="boat">
          <p class="fleetName">船名：携船159</p>
          <p class="fleetSub"><span>载重吨：6151T</span><span>类型：多用途船</span></p>
        </div>
      </div>
    </div>
    <div class="fleetInfo">
      <div class="innerFleet">
        <div>
          <img src="../assets/boat-9.png" class="boat">
          <p class="fleetName">船名：携船158</p>
          <p class="fleetSub"><span>载重吨：6045T</span><span>类型：多用途船</span></p>
        </div>
      </div>
      <div class="innerFleet">
        <div>
          <img src="../assets/boat-10.png" class="boat">
          <p class="fleetName">船名：港联1</p>
          <p class="fleetSub"><span>载重吨：4981T</span><span>类型：多用途船</span></p>
        </div>
      </div>
    </div>
    <div class="fleetInfo">
      <div class="innerFleet">
        <div>
          <img src="../assets/boat-11.jpg" class="boat">
          <p class="fleetName">船名：携船99</p>
          <p class="fleetSub"><span>载重吨：5054T</span><span>类型：散货船</span></p>
        </div>
      </div>
      <div class="innerFleet">
        <div>
          <img src="../assets/boat-12.jpg" class="boat">
          <p class="fleetName">船名：携船9</p>
          <p class="fleetSub"><span>载重吨：5000T</span><span>类型：散货船</span></p>
        </div>
      </div>
    </div>
    <div style="margin-top:1rem"></div>
    <foot></foot>
    <rightC></rightC>
  </div>
</template>
<script>
  import navs from '@/components/nav/head';
  import foot from '@/components/nav/footer';
  import rightC from '@/components/nav/rightFloat'

  export default {
    name: 'fleet',
    data() {
      return {
        current: 0
      }
    },
    components: {
      navs, foot, rightC
    },
    created() {

    }
  }
</script>
<style lang='less' rel='stylesheet/less'>
  @rem: 16rem;
  @col-f: #fff;
  .fleetBox {
    width: 100%;
    height: 160/@rem;
    background: url('../assets/gong-b.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: ceil(100%) ceil(100%);
    align-items: center;

    p {
      text-align: center;
      color: @col-f;
      font-size: 22/@rem;
      padding-top: 48/@rem;
      margin: 0;
      font-weight: 400;
    }

    .smallTitle {
      text-align: center;
      color: @col-f;
      font-size: 10/@rem;
      padding-top: 10/@rem;
      font-weight: 300;

    }
  }

  .fleetInfo {
    display: flex;
    justify-content: space-between;
    padding-left: 0.1rem;
    padding-right: 0.1rem;

    .innerFleet {
      flex: 1;
      margin-top: 0.6rem;

      div {
        width: 94%;
        margin: 0 auto;
        box-shadow: 0px 7px 27px 0px rgba(0, 0, 0, 0.06);

        .boat {
          width: 100%;
        }

        .fleetName {
          font-size: 11/@rem;
          color: #333;
          text-align: center;
          margin: 0;
          font-weight: 400;
        }

        .fleetSub {
          font-size: 9/@rem;
          color: #666;
          display: flex;
          justify-content: space-between;
          padding: 0.4rem 0.4rem;
          margin: 0
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/fleet.vue